import axios from "axios";
import Config from "../../../config/index";

import {
  GET_REJECTIONS_DOWNLOAD_FAILURE,
  GET_REJECTIONS_DOWNLOAD_REQUEST,
  GET_REJECTIONS_DOWNLOAD_SUCCESS,
  GET_REJECTIONS_REPORT_FAILURE,
  GET_REJECTIONS_REPORT_REQUEST,
  GET_REJECTIONS_REPORT_SUCCESS,
} from "./rejectionsReportTypes";
let baseUrl = Config.baseUrl;
let baseUrlReport = Config.baseUrlReport;


const getRejectionsReportRequest = () => {
  return {
    type: GET_REJECTIONS_REPORT_REQUEST,
  };
};

const getRejectionsReportSuccess = (payload) => {
  return {
    type: GET_REJECTIONS_REPORT_SUCCESS,
    payload: payload,
  };
};

const getRejectionsReportFailure = (error) => {
  return {
    type: GET_REJECTIONS_REPORT_FAILURE,
    payload: error,
  };
};

const getRejectionsReport = (pageNo, rowsPerPage, search, jwtToken) => {
  let headers = {
    headers: {
      Authorization: `Bearer ${jwtToken}`,
    },
  };
  return (dispatch) => {
    dispatch(getRejectionsReportRequest());
    let url = `${baseUrlReport}/rejection?download=0&page_number=${
      pageNo + 1
    }&rows_per_page=${rowsPerPage}&search=${search ? search : ""}&startDate=""&endDate=""`;
    axios
      .get(url, headers)
      .then((response) => {
        dispatch(getRejectionsReportSuccess(response.data));
      })
      .catch((err) => {
        dispatch(getRejectionsReportFailure(err.response));
      });
  };
};

const downloadRejectionsReportRequest = () => {
  return {
    type: GET_REJECTIONS_DOWNLOAD_REQUEST,
  };
};

const downloadRejectionsReportSuccess = (payload) => {
  return {
    type: GET_REJECTIONS_DOWNLOAD_SUCCESS,
    payload: payload,
  };
};

const downloadRejectionsReportFailure = (error) => {
  return {
    type: GET_REJECTIONS_DOWNLOAD_FAILURE,
    payload: error,
  };
};

const downloadRejectionsReport = (
  startDate,
  endDate,
  pageNo,
  rowsPerPage,
  search,
  jwtToken
) => {
  let headers = {
    headers: {
      Authorization: `Bearer ${jwtToken}`,
    },
  };
  return (dispatch) => {
    dispatch(downloadRejectionsReportRequest());
    let url = `${baseUrlReport}/rejection?download=1&startDate=${endDate}&endDate=${startDate}&page_number=${
      pageNo + 1
    }&rows_per_page=${rowsPerPage}&search=${search ? search : ""}`;
    axios
      .get(url, headers)
      .then((response) => {
        dispatch(downloadRejectionsReportSuccess(response.data));
      })
      .catch((err) => {
        dispatch(downloadRejectionsReportFailure(err.response));
      });
  };
};

export { getRejectionsReport, downloadRejectionsReport };
